import { H3, Text } from '@betterment/samba-react';

import { SambaAutoLink } from '~/b4b/components/SambaAutoLink';
import { urlBuilder } from '~/b4b/utils/urlBuilder';

export const SuspenseFund: React.FC = () => {
  return (
    <>
      <Text as="p" css={{ pb: 'space.200' }}>
        Suspense funds are accrued when excess employer contributions are corrected. Relinquished contributions and loan
        repayments also end up in the suspense fund. If you want to see when and why suspense funds were generated, you
        can{' '}
        <SambaAutoLink to={urlBuilder.reportsNew({ report: 'suspense_account' })}>
          run a suspense fund report
        </SambaAutoLink>
        . You can learn more about suspense funds in our{' '}
        <SambaAutoLink target="_blank" rel="noopener noreferrer" to={urlBuilder.getUnallocatedFundsGuide()}>
          Guide to unallocated funds
        </SambaAutoLink>
      </Text>

      <H3 variant="title100">Your suspense funds can be used in the following ways:</H3>

      <ul>
        <li>
          <Text as="p">To reduce planned employer contributions</Text>
        </li>
        <li>
          <Text as="p">
            To reallocate as unplanned employer contributions (including your employer match, safe harbor, QNEC and
            QMAC)
          </Text>
        </li>
      </ul>

      <Text as="p" css={{ pb: 'space.200' }}>
        If the{' '}
        <SambaAutoLink to={urlBuilder.unallocatedFundsAutomationEdit()}>
          Auto apply unallocated funds setting
        </SambaAutoLink>{' '}
        is on, we'll apply these funds to your payroll automatically. You can also contact support to use the funds in
        any of the other ways listed above.
      </Text>

      <H3 variant="title100">Timing requirements</H3>

      <Text as="p">
        Forfeiture funds typically need to be used by the end of the year after the year the forfeiture way accrued.
      </Text>
    </>
  );
};
